class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerBoundary = this.closest('.section-header') || this.header;
    this.hasFeaturedMenu = this.hasAttribute('data-has-featured-megamenu');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.onBoundaryMouseLeave = this.onBoundaryMouseLeave.bind(this);
    this.bindHoverEvents();
  }

  isMegamenuVisible() {
    return Boolean(document.querySelector('.megamenu-visible'));
  }

  get isFeaturedActive() {
    return this.hasFeaturedMenu && this.isMegamenuVisible();
  }

  connectedCallback() {
    if (this.hasFeaturedMenu && this.headerBoundary && !this.headerBoundary.featuredMenuMouseLeaveBound) {
      this.headerBoundary.addEventListener('mouseleave', this.onBoundaryMouseLeave);
      this.headerBoundary.featuredMenuMouseLeaveBound = true;
    }
  }

  disconnectedCallback() {
    this.unbindHoverEvents();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  bindHoverEvents() {
    if (!this.mainDetailsToggle) return;

    this.unbindHoverEvents();
    this.desktopMediaQuery.addEventListener('change', this.onBreakpointChange);

    if (!this.desktopMediaQuery.matches) return;

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
  }

  unbindHoverEvents() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.desktopMediaQuery.removeEventListener('change', this.onBreakpointChange);
  }

  onBreakpointChange() {
    this.bindHoverEvents();

    if (!this.desktopMediaQuery.matches) {
      this.close();
    }
  }

  onMouseEnter() {
    if (!this.desktopMediaQuery.matches || this.mainDetailsToggle.hasAttribute('open')) return;

    if (this.isFeaturedActive) {
      document.querySelectorAll('header-menu').forEach((headerMenu) => {
        if (headerMenu !== this && headerMenu.isFeaturedActive && typeof headerMenu.close === 'function') {
          headerMenu.close();
        }
      });
      this.classList.add('is-featured-open');
    }

    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;
    // Featured megamenu closes when leaving the header boundary, not the trigger.
    if (this.isFeaturedActive) return;
    this.close();
  }

  onBoundaryMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;

    document.querySelectorAll('header-menu').forEach((headerMenu) => {
      if (headerMenu.hasFeaturedMenu && headerMenu.isMegamenuVisible?.() && typeof headerMenu.close === 'function') {
        headerMenu.close();
      }
    });
  }

  close() {
    this.classList.remove('is-featured-open');
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
